import React from 'react'

const ReSchedulePolicy = () => {
  return (
    <div>ReSchedulePolicy</div>
  )
}

export default ReSchedulePolicy